module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/path.js
// module id = 151
// module chunks = 25